export type HistoricalReference = {
  value: number;
  measuredAt: string | null;
  occurrenceCount: number;
};

export type HistoricalAttributeSummary = {
  sampleCount: number;
  min: HistoricalReference;
  max: HistoricalReference;
  percentiles: {
    p05: number;
    p50: number;
    p95: number;
  };
};

export type ContextHistorySummary = {
  window: {
    from: string;
    to: string;
    days: number;
    basis: "measurement_time";
  };
  attributes: Record<string, HistoricalAttributeSummary>;
};

export const fetchContextHistorySummary = async (
  contextId: string,
  token?: string | null,
  days = 365,
): Promise<ContextHistorySummary> => {
  if (!contextId) throw new Error("Falta la estación.");

  const response = await fetch(
    `${process.env.REACT_APP_API_HOST || ""}/api/v1/contexts/${encodeURIComponent(contextId)}/history-summary?days=${days}`,
    {
      headers: {
        accept: "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    },
  );
  if (!response.ok) {
    const detail = await response.text().catch(() => "");
    throw new Error(detail || `No se pudo cargar el historial (${response.status}).`);
  }
  return response.json() as Promise<ContextHistorySummary>;
};
